var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.key}),_c('van-number-keyboard',{attrs:{"safe-area-inset-bottom":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }